import { Injectable } from '@angular/core';
import { ApiService } from 'app/00_modules/core/services/api.service';
import { lastValueFrom } from 'rxjs';
import { ErrorInformationFromUser } from '../models/ErrorInformationFromUser';

@Injectable({
    providedIn: 'root',
})
export class SubmitErrorServices {
    constructor(private apiService: ApiService) {}

    public submitError(errorInfo: ErrorInformationFromUser): Promise<ErrorInformationFromUser> {
        const url = `api/error/SendErrorEmail`;
        return lastValueFrom(this.apiService.post<ErrorInformationFromUser>(url, errorInfo));
    }
}
